export default "__VITE_ASSET__6a26d953__"